import { useQuery } from '@tanstack/react-query'
import { getWorkBreaks } from 'api/work'
import { workKeys } from './keys'
import { QueryOptions } from 'queries/types'
import { useAuthContext } from 'components/auth'

export function useWorkBreaks(
  workId: number,
  options: QueryOptions<typeof getWorkBreaks> = {}
) {
  const { company } = useAuthContext()
  const companyId = company?.id

  return useQuery({
    ...options,
    queryKey: workKeys.breaks(workId),
    queryFn: () => {
      if (companyId === undefined) {
        throw new Error('Company is required')
      }
      return getWorkBreaks(companyId, workId)
    },
    enabled: companyId !== undefined && (options.enabled ?? true),
  })
}
